import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useAssignRoom } from './use-assign-room';

import type { InteractiveTimeDashboardData } from '../interactiveTimeDashboard/types';
import type { QueryKey } from '@tanstack/react-query';
import type { IPatientAssignStateChange } from 'infrastructure/interfaces';

export const useUpdateAssigneeInteractiveTimeDashboard = (
  queryKey: QueryKey,
) => {
  const queryClient = useQueryClient();

  const callBack = useCallback((data: IPatientAssignStateChange) => {
    queryClient.setQueryData<InteractiveTimeDashboardData>(
      queryKey,
      (oldData) => {
        if (!oldData) return oldData;

        const newData = oldData.data.map((item) => {
          if (item.patient.guid === data.patientGuid) {
            return {
              ...item,
              assignee: data.assignee,
            };
          }
          return item;
        });
        return { count: oldData.count, data: newData };
      },
    );
  }, []);

  useAssignRoom(callBack);
};
